module.exports = __webpack_public_path__ + "static/media/mq.6fc074f9.svg";